import { render, staticRenderFns } from "./AttachmentField.vue?vue&type=template&id=36241c54&"
import script from "./AttachmentField.vue?vue&type=script&lang=js&"
export * from "./AttachmentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports